<template>
<div>

  <div v-if="spinner" class="d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
 <div v-else>
  <form>  
  <p class="text-center mt-4" style="color:red"><strong>{{data}}</strong></p>  
  <div class="form-row">
    <div class="col">
      <label>NUMERO SCONTRINO</label>
      <input v-focus type="text" @input="msg=''" ref="numsco"  maxlength="4" v-on:keydown="keyHandler($event,'Num')" class="form-control" placeholder="0000" v-model="creditNote.numsco">
     
    </div>
    <div class="col">
      <label>NUMERO RAPPORTO</label>     
      <input type="text" ref="znumber"  @input="msg=''"  v-on:keydown="keyHandler($event,'Num')" maxlength="4"  class="form-control" placeholder="0000" v-model="creditNote.znumber">
     
    </div>
    <div class="col">
      <label>DATA SCONTRINO</label>
      <input type="text" ref="datasco" @input="msg=''"  v-on:keydown="keyHandler($event,'Num')"  maxlength="8"  class="form-control" placeholder="GGMMAAAA" v-model="creditNote.datasco">
       
    </div>
  </div>
  
</form>
<p class="text-center mt-4" style="color:red"><strong>{{msg}}</strong></p>


 </div> 

</div>

</template>

<script>
import api                from '@/api'
import keyHandler         from '@/components/mixins/keyHandler'
export default {
   mixins: [keyHandler],
   props:['fiscalReceiptSaleId'],

  data() {
    return {
      
      creditNote : {
        numsco : ''
      },
      msg        : '',
      spinner    : true,
      data       : ''
            
    };
  },
    directives: {
    focus: {
      // directive definition
      inserted: function(el) {
                
        el.focus();
      }
    }
  },

  
  created () 
      {
        
        this.$emit('setButton',false)
        this.getData()
      },  
  methods: 
  {
   
  async   getData()
    {
      
      const sp         = {'sp'   : 'spSaleFiscalReceipt'}
      const data       = {'saleId' : this.fiscalReceiptSaleId }
      const json       = Object.assign(data, sp)
  
  
      await api.post(json).then(res => {

        if(res.status == 200)
        {
          
          if(res.data.recordsets[0].length > 0)
          {
            this.creditNote.numsco  = res.data.recordsets[0][0].fiscalReceiptNumber
            this.creditNote.znumber = res.data.recordsets[0][0].zRepNumber
            this.creditNote.datasco = res.data.recordsets[0][0].fiscalReceiptDate
          }
          else
          {
            this.data = 'DATI SCONTRINO DI VENDITA NON TROVATI.'
          }
        }
        else if(res.status==500)
          {
            console.log(res.data)
            
          }
          else
          {
            console.log(res)
            
          } 

        })
        .catch(err => 
      {
      
        console.log(err.message)
      }).finally(() => {
        this.spinner = false
        this.$emit('setButton',true)
      });
    },
    checkData()
    {

        
        const isDateValid = (dateObj) => {
            return !isNaN(new Date(dateObj));
            }   


      this.msg = ''
     
      if(!this.creditNote.numsco)
      {
        
        this.msg = 'NUMERO SCONTRINO NON VALIDO.'

        this.$nextTick(function () {
        
            this.$refs['numsco'].focus()
        
        })
        
        return 
      }
      else if(this.creditNote.numsco.length !=4 )
      {
        this.msg = 'NUMERO SCONTRINO NON VALIDO.'
         this.$nextTick(function () {
        
            this.$refs['numsco'].focus()
        
        })
        return
        
      }
      else if(parseInt(this.creditNote.numsco)==0)
      {
        this.msg = 'NUMERO SCONTRINO NON VALIDO.'
         this.$nextTick(function () {
        
            this.$refs['numsco'].focus()
        
        })
        return 
        
      }

      else if(!this.creditNote.znumber)
      {
        this.msg = 'NUMERO RAPPORTO NON VALIDO.'
         this.$nextTick(function () {
        
            this.$refs['znumber'].focus()
        
        })
        return
        
      }
      else if(this.creditNote.znumber.length != 4)
      {
        this.msg = 'NUMERO RAPPORTO NON VALIDO.'
        this.$nextTick(function () {
        
            this.$refs['znumber'].focus()
        
        })
        return
        
      }
      else if(parseInt(this.creditNote.znumber)  == 0)
      {
        this.msg = 'NUMERO RAPPORTO NON VALIDO.'
        this.$nextTick(function () {
        
            this.$refs['znumber'].focus()
        
        })
        return
        
      }
      else if(!this.creditNote.datasco)
      {
        this.msg = 'DATA SCONTRINO NON VALIDA.'
        this.$nextTick(function () {
        
            this.$refs['datasco'].focus()
        
        })
        return
        
      }
      else if (this.creditNote.datasco.length != 8)
      {
        this.msg = 'DATA SCONTRINO NON VALIDA.'
        this.$nextTick(function () {
        
            this.$refs['datasco'].focus()
        
        })
        
      }  
        

      
      if(!this.msg)
      {
          this.$emit('update',this.creditNote)
      }
    },
   

    
}
}

</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;  
}
small {
  font-family  : 'Roboto Condensed';
  font-size    : 10px;
}

::placeholder {
  color: rgb(106, 17, 223);
  opacity: 1; /* Firefox */
}



input {
  font-weight: bold;
}


</style>


